var ObjectConverter = /** @class */ (function () {
    function ObjectConverter() {
    }
    ObjectConverter.prototype.convertMany = function (objectArray) {
        var _this = this;
        return objectArray.map(function (objectInstance) { return _this.convert(objectInstance); });
    };
    return ObjectConverter;
}());
export default ObjectConverter;
//# sourceMappingURL=ObjectConverter.js.map